import React from 'react'
import PropTypes from 'prop-types'

const Card = ({
  image, className, onClick, title, content, classContent, label, id
}) => {
  return (
    <div className={`${className} card-container`} onClick={onClick} id={id}>
      <img width={88} height={82} src={image} alt="" />
      <div>
        <p className='flex align-items-center'>
          {title}
          {label && <span className='new-tag'>{label}</span>}
        </p>
        <p className={classContent}>
          {content}
        </p>
      </div>
    </div>
  )
}

export default Card
Card.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  classContent: PropTypes.string,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  label: PropTypes.string,
  id: PropTypes.string.isRequired
}
Card.defaultProps = {
  className: '',
  classContent: '',
}
